import { IControl, Map } from 'maplibre-gl';

export class CustomControl implements IControl {
    private _map: Map | undefined;
    private _container!: HTMLElement;

    constructor(container: HTMLElement) {
        this._container = container;
    }

    onAdd(map: Map): HTMLElement {
        this._map = map;
        return this._container;
    }

    onRemove(): void {
        if (this._container && this._container.parentNode) {
            this._container.parentNode.removeChild(this._container);
        }
        this._map = undefined;
    }
}